/**
 * Escape closes an open header submenu, even while the pointer is still over
 * the nav item. The stock component only opens and closes on pointer and
 * focus, so pressing Escape left the panel on screen.
 */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  const open = document.querySelectorAll('.header-menu .menu-list__link[aria-expanded="true"]');
  if (open.length === 0) return;

  for (const link of open) {
    link.setAttribute('aria-expanded', 'false');
    if (link.contains(document.activeElement) || link === document.activeElement) link.blur();
  }
});
